module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event-card"
  }, [_c('a', {
    attrs: {
      "href": _vm.url
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "width": "100%"
    },
    on: {
      "error": _vm.onImageLoadError
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "stat"
  }, [_c('date-range', {
    attrs: {
      "start": _vm.start,
      "end": _vm.end,
      "timezone": _vm.timezone,
      "showDate": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "stat"
  }, [_c('date-range', {
    attrs: {
      "start": _vm.start,
      "end": _vm.end,
      "timezone": _vm.timezone,
      "showTime": true,
      "showTimezone": _vm.showTimezone
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "stat location"
  }, [_vm._v(_vm._s(_vm.location))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45486672!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/molecules/event-card/event-card.vue
// module id = 644
// module chunks = 4